// utils/SocketService.js
import { io } from 'socket.io-client';
import LoggedInUserService from './AuthService'
import AppConfig from '../AppConfig';

let socket;

export const initializeSocket = () => {
  const tdata = LoggedInUserService.GetLoggedInUserData();
  if (!tdata) return false;
  if (socket && socket.io.opts.query?.id !== tdata.id) {
    socket.disconnect();
    socket = null;
  }
  if (!socket) {
    socket = io(AppConfig.PfqBaseUrl, {
      query: { id: tdata.id },
      reconnection: true,
      withCredentials: true,
    });
    socket.on('connect', () => {
      console.log('Connected to Socket.IO server.');
    });
  }
  return socket;
};

export const getSocket = () => socket;

export const onSocketEvent = (eventName, callback) => {
  if (socket) {
    socket.on(eventName, callback);
  }
};

export const offSocketEvent = (eventName, callback) => {
  if (socket) {
    socket.off(eventName, callback);
  }
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
